<nb-card>
  <nb-card-body style="margin-top: 0;">
    <div class="row">
      <div class="col-lg-12 col-12">
        <label>
          <h4>Scan {{data.isLotScan ? "Lot" : "Location"}}</h4>
        </label>

        <mat-divider></mat-divider>
        <mat-form-field class="inputMarginTop" [nbSpinner]="this.isLoading">
          <input [(ngModel)]="this.tagNumber" (keyup.enter)="scanLocation()" placeholder="Barcode" style="width: 100%;" matInput
            type="text" #tagNumberInput id="tagNumberInput" name="tagNumberInput">
          <button style="margin-right: 8px;"  matSuffix mat-icon-button aria-label="Clear" type="button">
            <fa-icon [icon]="faBarcode" size="2x"></fa-icon>
          </button>
        </mat-form-field>
      </div>
    </div>

    <!-- BULK MOVE BARCODES -->
    <div class="row" *ngIf="data.isMultiple">
      <div class="col-lg-12 col-12" style="text-align: left; max-height: 200px; overflow: auto;">
        <h5>
          <li *ngFor="let x of this.handlingUnitBulkMoveList">
            {{x.tagNumber}}
        </li>
        </h5>
      </div>
    </div>
    <div class="row justify-content-center" *ngIf='this.tagNotFound' style="margin-bottom: 15px">
      <div class="col-11 alert">
        Tag not found. Please try another.
      </div>
    </div>
    <div class="row justify-content-center">
      <div class="col-11" style="text-align:center;">
      </div>
    </div>
  </nb-card-body>
  <nb-card-footer>
    <div class="row">
      <div class="col-6" style="text-align: left;">

            <button class="closeButton" mat-raised-button type="button" (click)="close(null)">
              Close
            </button>
      </div>
      <div class="col-6" style="text-align: right;">
        <!-- <button *ngIf="data.isMultiple" [disabled]="this.handlingUnitBulkMoveList.length <= 0" class="bulkMoveButton" mat-raised-button type="button" (click)="bulkMoveNext()" style="margin-left: 15px;">
          Next
        </button> -->
        <button *ngIf="!data.isMultiple" class="bulkMoveButton" mat-raised-button type="button" (click)="scanLocation()" style="margin-left: 15px;">
          Next
        </button>
      </div>
    </div>
  </nb-card-footer>
</nb-card>